import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import {
	Overlay,
	OverlayBlur,
	PopupContainer,
	PopupHeader,
	PopupBody,
	Label,
	ButtonCancel,
	ButtonConfirm,
	PopupFooter,
	ButtonAccept,
} from './styles';
import keys from '../../utils/keys';

interface FooterData {
	label: string;
	onAccept: () => void;
}
interface PopupProps {
	isDisplayed: boolean;
	label: string;
	onCancel?: () => void;
	onConfirm?: () => void;
	isConfirmDisabled?: boolean;
	footer?: FooterData;
	actionButtonColor?: string;
}

const Popup: React.FunctionComponent<PopupProps> = ({
	isDisplayed,
	label,
	onCancel,
	onConfirm,
	isConfirmDisabled,
	children,
	footer,
	actionButtonColor,
}) => {
	const handleOverlayClick = (e: MouseEvent | TouchEvent) => {
		if (onCancel && e.target === e.currentTarget) {
			onCancel();
		}
	};

	React.useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			if (keys.isEnter(e.keyCode) && onConfirm && !isConfirmDisabled) {
				e.preventDefault();
				onConfirm();
			}

			if (keys.isEsc(e.keyCode) && onCancel) {
				e.preventDefault();
				onCancel();
			}
		};

		if (isDisplayed) {
			window.addEventListener('keydown', handleKeyDown);
		}

		return () => {
			if (isDisplayed) {
				window.removeEventListener('keydown', handleKeyDown);
			}
		};
	}, [isDisplayed, onConfirm, onCancel, isConfirmDisabled]);

	return (
		<Overlay isOpen={isDisplayed}>
			<OverlayBlur
				onMouseDown={handleOverlayClick}
				onTouchStart={handleOverlayClick}
			>
				{isDisplayed && (
					<PopupContainer>
						<PopupHeader>
							{onCancel &&
								<ButtonCancel
									type="button"
									color={actionButtonColor}
									onClick={onCancel}
								>
									<Translate value="messages.cancel" />
								</ButtonCancel>
							}
							<Label>{label}</Label>
							{onConfirm &&
								<ButtonConfirm
									type="button"
									color={actionButtonColor}
									onClick={onConfirm}
									disabled={isConfirmDisabled}
								>
									<Translate value="messages.ok" />
								</ButtonConfirm>
							}
						</PopupHeader>
						<PopupBody>
							{children}
						</PopupBody>
						{
							footer && <PopupFooter>
								<ButtonAccept
									type="button"
									onClick={footer.onAccept}
								>
									{footer.label}
								</ButtonAccept>
							</PopupFooter>
						}
					</PopupContainer>
				)}
			</OverlayBlur>
		</Overlay>
	);
};

export { FooterData };
export default Popup;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Popup/index.tsx